import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Linkedin, ArrowLeft, Sparkles } from 'lucide-react';

const LoginPage = () => {
  const navigate = useNavigate();
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  const handleLinkedInLogin = () => {
    // Redirect to LinkedIn OAuth
    window.location.href = `${BACKEND_URL}/api/auth/linkedin`;
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 flex items-center justify-center p-4">
      {/* Back to Home Button */}
      <Button
        variant="ghost"
        onClick={() => navigate('/')}
        className="absolute top-4 left-4"
      >
        <ArrowLeft className="w-4 h-4 mr-2" />
        Back to Home
      </Button>

      <Card className="w-full max-w-md shadow-2xl">
        <CardHeader className="text-center">
          <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
            <Sparkles className="w-8 h-8 text-white" />
          </div>
          <CardTitle className="text-3xl font-bold">Welcome to RecruiterIQ</CardTitle>
          <CardDescription className="text-base mt-2">
            Sign in with your LinkedIn account to access AI-powered recruitment intelligence
          </CardDescription>
        </CardHeader>
        
        <CardContent className="space-y-6">
          {/* LinkedIn Sign In Button */}
          <Button
            onClick={handleLinkedInLogin}
            className="w-full bg-[#0A66C2] hover:bg-[#004182] text-white py-6 text-lg font-semibold"
          >
            <Linkedin className="w-6 h-6 mr-3" />
            Continue with LinkedIn
          </Button>

          {/* Information Section */}
          <div className="bg-blue-50 rounded-lg p-4 space-y-2">
            <h3 className="font-semibold text-slate-900 text-sm">Why LinkedIn?</h3>
            <ul className="text-sm text-slate-700 space-y-1">
              <li className="flex items-start gap-2">
                <span className="text-blue-600 mt-1">✓</span>
                <span>Instant access with your professional profile</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-blue-600 mt-1">✓</span>
                <span>Secure authentication through LinkedIn</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-blue-600 mt-1">✓</span>
                <span>No password to remember</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-blue-600 mt-1">✓</span>
                <span>Perfect for recruiting professionals</span>
              </li>
            </ul>
          </div>

          {/* Privacy Note */}
          <p className="text-xs text-center text-slate-500">
            By signing in, you agree to our{' '}
            <a href="/terms-conditions" className="text-blue-600 hover:underline">Terms & Conditions</a>
            {' '}and{' '}
            <a href="/privacy-policy" className="text-blue-600 hover:underline">Privacy Policy</a>
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default LoginPage;
